export default function CsvService() {
  'ngInject'

  function isSafari() {
    return (
      /constructor/i.test(window.HTMLElement) ||
      (function(p) {
        return p.toString() === '[object SafariRemoteNotification]'
      })(!window['safari'] || safari.pushNotification)
    )
  }

  function isFirefox() {
    return typeof InstallTrigger !== 'undefined'
  }

  function validSafari() {
    if (isSafari()) {
      var version = parseInt(
        navigator.appVersion
          .split('Version/')[1]
          .split('Safari/')[0]
          .split('.')[0],
      )
      if (version < 10) {
        swal('Safari 10.x or higher required.', '', 'warning')
        return
      }
    }
  }

  function convertArrayOfObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data
    data = args.data || null

    if (data == null || !data.length) {
      return null
    }

    columnDelimiter = args.columnDelimiter || ','
    lineDelimiter = args.lineDelimiter || '\n'
    keys = Object.keys(data[0])

    result = ''
    result += keys.join(columnDelimiter)
    result += lineDelimiter

    data.forEach(function(item) {
      ctr = 0
      keys.forEach(function(key) {
        if (ctr > 0) result += columnDelimiter
        result += item[key]
        ctr++
      })

      result += lineDelimiter
    })
    return result
  }

  function csvToArray(strData, strDelimiter) {
    if (strData == '') {
      return
    }

    strDelimiter = strDelimiter || ','

    var objPattern = new RegExp(
      '(\\' +
        strDelimiter +
        '|\\r?\\n|\\r|^)' +
        '(?:"([^"]*(?:""[^"]*)*)"|' +
        '([^"\\' +
        strDelimiter +
        '\\r\\n]*))',
      'gi',
    )

    var arrData = [[]]
    var arrMatches = null

    while ((arrMatches = objPattern.exec(strData))) {
      var strMatchedDelimiter = arrMatches[1]
      if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
        arrData.push([])
      }

      var strMatchedValue

      if (arrMatches[2]) {
        strMatchedValue = arrMatches[2].replace(new RegExp('""', 'g'), '"')
      } else {
        strMatchedValue = arrMatches[3]
      }

      arrData[arrData.length - 1].push(strMatchedValue)
    }

    return arrData
  }

  return {
    validSafari: validSafari,
    convertArrayOfObjectsToCSV: convertArrayOfObjectsToCSV,
    csvToArray: csvToArray,
    isSafari: isSafari,
    isFirefox: isFirefox,
  }
}
